import React from 'react';
import { INTERFACE_TEXT } from '../../constants/interfaceText';
import { useModalDialog } from './PauseOverlay';
import styles from './PauseOverlay.module.css';

/** Asks before leaving mid-session. Progress is kept and leaving is never penalised (BR-013). */
export const LeaveConfirm: React.FC<{
  onStay: () => void;
  onLeave: () => void;
}> = ({ onStay, onLeave }) => {
  const ref = useModalDialog(onStay);
  return (
    <div className={styles.overlay}>
      <div
        ref={ref}
        className={styles.dialog}
        role="dialog"
        aria-modal="true"
        aria-labelledby="leave-heading"
        aria-describedby="leave-body"
      >
        <h3 id="leave-heading" className={styles.heading}>
          {INTERFACE_TEXT.tsLeaveHeading}
        </h3>
        <p id="leave-body" className={styles.body}>
          {INTERFACE_TEXT.tsLeaveBody}
        </p>
        <button type="button" className={styles.primary} onClick={onStay}>
          {INTERFACE_TEXT.tsStay}
        </button>
        <button type="button" className={styles.secondary} onClick={onLeave}>
          {INTERFACE_TEXT.tsLeave}
        </button>
      </div>
    </div>
  );
};

export default LeaveConfirm;
